import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconMessageQuestion,
  IconShieldCog,
  IconUserCog,
  IconUsers,
  IconUsersGroup,
} from '@tabler/icons-react'

export const userRequestModuleKey = 'user_request'
export const usersModuleKey = 'users'
export const userSearchModuleKey = 'users_search'
export const workerClientsModuleKey = 'worker_clients'
export const clientRolesModuleKey = 'client_roles'

const userRequestRoute: RouteConfig = {
  uid: usersModuleKey,
  path: '/users/users-requests',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/users/user-requests')).default,
  }),
}

const usersRoute: RouteConfig = {
  uid: usersModuleKey,
  path: '/users/user',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/users/users')).default,
  }),
}

const usersEditRoute: RouteConfig = {
  uid: usersModuleKey,
  path: '/users/user/edit/:userId',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/users/users/edit')).default,
  }),
}

const workerClientsRoute: RouteConfig = {
  uid: workerClientsModuleKey,
  path: '/users/worker-clients',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/users/worker-clients')).default,
  }),
}

const workerClientsCreateRoute: RouteConfig = {
  uid: workerClientsModuleKey,
  path: '/users/worker-clients/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/users/worker-clients/create')).default,
  }),
}

const workerClientsDetailRoute: RouteConfig = {
  uid: workerClientsModuleKey,
  path: '/users/worker-clients/:workerId/:warehouseId',
  type: 'retrieve',
  lazy: async () => ({
    Component: (await import('@/pages/users/worker-clients/detail')).default,
  }),
}

const clientRolesRoute: RouteConfig = {
  uid: clientRolesModuleKey,
  path: '/users/client-roles',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/users/client-roles')).default,
  }),
}

const clientRolesCreateRoute: RouteConfig = {
  uid: clientRolesModuleKey,
  path: '/users/client-roles/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/users/client-roles/role-create')).default,
  }),
}

const clientRolesEditRoute: RouteConfig = {
  uid: clientRolesModuleKey,
  path: '/users/client-roles/:roleId/edit',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/users/client-roles/role-edit')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Users',
  href: '',
  icon: <IconUserCog size={18} />,
  order: 3.9,
  sub: [
    {
      uid: usersModuleKey,
      title: 'users',
      href: '/users/user',
      icon: <IconUsers size={18} />,
      order: 1,
    },
    {
      uid: workerClientsModuleKey,
      title: 'worker_clients',
      href: '/users/worker-clients',
      icon: <IconUsersGroup size={18} />,
      order: 2,
    },
    {
      uid: clientRolesModuleKey,
      title: 'client_roles',
      href: '/users/client-roles',
      icon: <IconShieldCog size={18} />,
      order: 3,
    },
    {
      uid: usersModuleKey,
      title: 'user requests',
      href: '/users/users-requests',
      icon: <IconMessageQuestion size={18} />,
      order: 4,
    },
  ],
}

export default [
  userRequestRoute,
  usersRoute,
  usersEditRoute,
  workerClientsRoute,
  workerClientsCreateRoute,
  workerClientsDetailRoute,
  clientRolesRoute,
  clientRolesCreateRoute,
  clientRolesEditRoute,
]
